import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { resetAuthSessionQueries } from "../runtime/resetAuthSessionQueries";
import { clearHttpAccessToken } from "../../../lib/http/accessToken";

/** 清理前端登录态并回到登录页。 */
export function LogoutPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    clearHttpAccessToken();
    resetAuthSessionQueries(queryClient);
    navigate("/auth/login", { replace: true });
  }, [navigate, queryClient]);

  return null;
}
